/* eslint-disable jsx-a11y/img-redundant-alt */
import { getAssetDetailApi,returnAssetApi } from "api/services/assets";
import Image from "components/Image";
import AllAssetAddPopup from "components/modelpopup/AllAssetAddPopup";
import AssetAssignPopup from "components/modelpopup/assignAssetPopup";
import ReturnAssetModal from "components/modelpopup/ReturnAssetModal";
import { useEffect,useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link,useLocation,useNavigate,useParams } from "react-router-dom";
import { Bounce,toast } from 'react-toastify';
import { formatDateHandler2 } from "utils/common";
import { useAssets } from "./../context/assetContext";
import AssetAttachment from "./AssetAttachment";

const AssetDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [assetData, setAssetData] = useState({})
  const [attachmentData, setAttachmentData] = useState([]) 
  const [returnAssetModal, setReturnAssetModal] = useState(false)

    useEffect(()=>{
if(params?.id){
  fetchAssetDetail(params?.id)
}
  },[params?.id])

  const fetchAssetDetail = (id) => {
    getAssetDetailApi(id).then(response=>{
      setAssetData(response.data)
      setAttachmentData([{url:response.data?.image}])
    })
  }
  
   const {
      loading,
    assetCategory,
      setLoading,
    handleAssetDetailPage
    } = useAssets();

const [selectedAsset, setSelectedAsset] = useState()
const [assetModal, setAssetModal] = useState(false)
const [selectedAssetUser, setSelectedAssetUser] = useState()
const [assetUserModal, setAssetUserModal] = useState(false)

const returnAssetHandler = (props) => {
  returnAssetApi(selectedAssetUser?.id, {
    approval_status: "",
    comment: ""
  }).then(res=>{
    toast.success('Asset return request initiated successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });
      fetchAssetDetail(assetData?.id)
      setReturnAssetModal(false)
  }).catch(e=>{
    toast.error('Error initiating asset return!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });
  })
}

  const handleClickGoBack = () => {
    navigate('/assets');
  };

  // Prepare asset information for grid display
  const assetInfo = [
    { id: 1, title: "Brand", text: assetData?.brand || "N/A" },
    { id: 2, title: "Serial Number", text: assetData?.serial_number || "N/A" },
    { id: 3, title: "Purchase Date", text: formatDateHandler2(assetData?.purchase_date) || "N/A" },
    { id: 4, title: "Purchase Value", text: assetData?.purchase_value || "N/A" },
    { id: 5, title: "Status", text: assetData?.status ? "ACTIVE" : "INACTIVE", isBadge: true, badgeType: assetData?.status ? "success" : "danger" },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid" style={{ padding: isMobile ? "12px 8px" : "16px" }}>
          {/* Header with Navigation */}
          <div style={{ 
            marginBottom: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px"
          }}>
            <div>
              <Link 
                to="/assets" 
                onClick={(e) => {
                  e.preventDefault();
                  handleClickGoBack();
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "rgb(211, 0, 26)",
                  textDecoration: "none",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "4px"
                }}
              >
                <i className="las la-arrow-left"></i>
                Back to Assets
                        </Link>
              <h2 style={{ 
                fontSize: isMobile ? "18px" : "20px",
                fontWeight: "600",
                color: "#1f2937",
                margin: 0
              }}>
                Asset Detail
              </h2>
            </div>
                      </div>

          {/* Main Asset Card */}
          <div className="card shadow-sm" style={{ 
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            marginBottom: "16px",
            position: "relative"
          }}>
            <div style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              zIndex: 10
            }}>
                                         <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedAsset(assetData);
                  setAssetModal(true);
                }}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(211, 0, 26, 0.2)";
                }}
                                         >
                <i className="fa-solid fa-pencil" style={{ fontSize: "14px" }}></i>
                                         </Link>
                                       </div>

            <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
              {/* Asset Image and Name */}
              <div style={{ 
                marginBottom: "16px",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "16px",
                alignItems: isMobile ? "center" : "flex-start"
              }}>
                {/* Asset Image */}
                <div style={{
                  width: isMobile ? "100%" : "200px",
                  height: isMobile ? "200px" : "200px",
                  background: "#f9fafb",
                  borderRadius: "8px",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  border: "1px solid #e5e7eb"
                }}>
                  <Image 
                    src={assetData?.image} 
                    type="object" 
                    alt="Asset Image"
                    style={{ 
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain"
                    }}
                  />
                </div>

                {/* Asset Name and Description */}
                <div style={{ flex: 1, paddingRight: "50px" }}>
                  <h1 style={{ 
                    fontSize: isMobile ? "18px" : "22px",
                    fontWeight: "700",
                    color: "#1f2937",
                    marginBottom: "8px",
                    lineHeight: "1.2"
                  }}>
                    {assetData?.name || "Untitled Asset"}
                  </h1>
                  {assetData?.description && (
                    <p style={{
                      fontSize: "14px",
                      color: "#6b7280",
                      marginBottom: "12px",
                      lineHeight: "1.5"
                    }}>
                      {assetData.description}
                    </p>
                  )}
                </div>
                            </div>                      
                           
              {/* Asset Information Grid */}
              <div style={{
                borderTop: "1px solid #e5e7eb",
                paddingTop: "16px",
                marginBottom: "16px"
              }}>
                <div className="row g-2">
                  {assetInfo.map((item) => (
                    <div key={item.id} className={isMobile ? "col-12" : "col-md-6"}>
                      <div style={{
                        background: "#ffffff",
                        padding: "12px",
                        borderRadius: "6px",
                        border: "1px solid #e5e7eb"
                      }}>
                        <div style={{ 
                          fontSize: "11px", 
                          color: "#9ca3af", 
                          marginBottom: "4px",
                          fontWeight: "500",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px"
                        }}>
                          {item.title}
                            </div>
                        <div style={{ 
                          fontSize: "14px", 
                          color: "#1f2937",
                          fontWeight: "600"
                        }}>
                          {item.isBadge ? (
                            <span className={`badge badge-soft-${item.badgeType}`} style={{
                              fontSize: "12px",
                              padding: "4px 10px",
                              borderRadius: "4px",
                              fontWeight: "600"
                            }}>
                              {item.text}
                            </span>
                          ) : (
                            item.text
                          )}
                            </div>
                            </div>
                          </div>
                  ))}
                              </div>
                              </div>

              {/* Attachments Section */}
              {attachmentData?.length > 0 && (
                <div style={{
                  borderTop: "1px solid #e5e7eb",
                  paddingTop: "16px",
                  marginBottom: "16px"
                }}>
                  <div style={{ 
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#1f2937",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px"
                  }}>
                    <i className="fa-solid fa-paperclip" style={{ color: "#6b7280", fontSize: "14px" }}></i>
                    Attachments ({attachmentData.length})
                              </div>
                  <AssetAttachment assetData={attachmentData} />
                              </div>
              )}

              {/* Current Owner - If Available */}
              {assetData?.current_owner?.company_user && (
                <div style={{
                  borderTop: "1px solid #e5e7eb",
                  paddingTop: "16px",
                  marginTop: "16px"
                }}>
                  <div style={{ 
                    fontSize: "11px",
                    color: "#9ca3af",
                    marginBottom: "8px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  }}>
                    Current Owner
                                  </div>                              
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    background: "#f9fafb",
                    padding: "12px",
                    borderRadius: "6px"
                  }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "2px solid #e5e7eb",
                      flexShrink: 0,
                      background: "#ffffff"
                    }}>
                      <Image 
                        src={assetData.current_owner.company_user?.profile_image} 
                        type="user" 
                        style={{ objectFit: "cover", width: "100%", height: "100%" }}
                      />
                              </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Link
                        to={`/employees/${assetData.current_owner.company_user.id}`}
                        style={{
                          fontSize: "14px",
                          color: "#D3001A",
                          fontWeight: "600",
                          textDecoration: "none",
                          display: "block",
                          marginBottom: "2px"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = "none";
                        }}
                      >
                        {assetData.current_owner.company_user?.first_name} {assetData.current_owner.company_user?.last_name}
                      </Link>
                      {assetData.current_owner.company_user?.emp_no && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {assetData.current_owner.company_user.emp_no}
                        </div>
                      )}
                      {assetData.current_owner.company_user?.position_name && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280",
                          marginBottom: "2px"
                        }}>
                          {assetData.current_owner.company_user.position_name}
                      </div>
                      )}
                      {assetData.current_owner.company_user?.email && (
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#6b7280"
                        }}>
                          {assetData.current_owner.company_user.email}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
                        </div>
                     </div>

          {/* History Section */}
          <div className="card shadow-sm" style={{ 
            borderRadius: "8px",
            border: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
            marginBottom: "16px"
          }}>
            <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
                flexWrap: "wrap",
                gap: "12px"
              }}>
                <h3 style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#1f2937",
                  margin: 0
                }}>
                  Assignment History
                </h3>
                      <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setAssetUserModal(true);
                    setSelectedAssetUser("");
                  }}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "rgb(211, 0, 26)",
                    textDecoration: "none",
                    fontSize: "13px",
                    fontWeight: "500",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    background: "rgba(211, 0, 26, 0.1)",
                    transition: "all 0.2s ease"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(211, 0, 26, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(211, 0, 26, 0.1)";
                  }}
                          >
                            <i className="la la-edit"></i> Reassign/Assign Asset
                          </Link>
                      </div>
                      
              {assetData?.user_assets?.length > 0 ? (
                <div className="row g-3">
                  {assetData.user_assets.map((item, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-4">
                      <div className="card shadow-sm" style={{
                        borderRadius: "8px",
                        border: "1px solid #e5e7eb",
                        background: "#ffffff",
                        position: "relative",
                        transition: "all 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                      }}
                      >
                        {/* Action Icons */}
                        <div style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          display: "flex",
                          gap: "6px",
                          zIndex: 10
                        }}>
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSelectedAssetUser(item);
                              setAssetUserModal(true);
                            }}
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "6px",
                              background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#ffffff",
                              textDecoration: "none",
                              boxShadow: "0 2px 6px rgba(211, 0, 26, 0.3)"
                            }}
                          >
                            <i className="fa-solid fa-pencil" style={{ fontSize: "12px" }}></i>
                          </Link>
                          {item.status && (
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedAssetUser(item);
                                setReturnAssetModal(true);
                              }}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ffffff",
                                textDecoration: "none",
                                boxShadow: "0 2px 6px rgba(211, 0, 26, 0.3)"
                              }}
                                         >
                              <i className="fa-solid fa-arrow-rotate-left" style={{ fontSize: "12px" }}></i>
                                         </Link>
                          )}
                        </div>

                        <div className="card-body" style={{ padding: "16px" }}>
                          {/* User Info */}
                          <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "12px",
                            paddingRight: "60px"
                          }}>
                            <div style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "50%",
                              overflow: "hidden",
                              border: "2px solid #e5e7eb",
                              flexShrink: 0,
                              background: "#ffffff"
                            }}>
                              <Image 
                                src={item?.company_user?.profile_image} 
                                type="user" 
                                style={{ objectFit: "cover", width: "100%", height: "100%" }}
                              />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                          <Link
                                to={`/employees/${item?.company_user?.id}`}
                                style={{
                                  fontSize: "14px",
                                  color: "#D3001A",
                                  fontWeight: "600",
                                  textDecoration: "none",
                                  display: "block",
                                  marginBottom: "2px"
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.textDecoration = "underline";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.textDecoration = "none";
                                }}
                              >
                                {item?.company_user?.first_name} {item?.company_user?.last_name}
                                          </Link>
                              {item?.company_user?.emp_no && (
                                <div style={{ 
                                  fontSize: "12px", 
                                  color: "#6b7280",
                                  marginBottom: "2px"
                                }}>
                                  {item.company_user.emp_no}
                                </div>
                              )}
                              {item?.company_user?.position_name && (
                                <div style={{ 
                                  fontSize: "12px", 
                                  color: "#6b7280"
                                }}>
                                  {item.company_user.position_name}
                                </div>
                              )}
                            </div>
                                  </div>
                             
                          {/* Assignment Details */}
                          <div style={{
                            borderTop: "1px solid #e5e7eb",
                            paddingTop: "12px"
                          }}>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>
                                Issue Date
                              </div>
                              <div style={{ fontSize: "13px", color: "#1f2937", fontWeight: "500" }}>
                                {formatDateHandler2(item?.issue_date) || "N/A"}
                              </div>
                            </div>
                            {item?.return_date && (
                              <div style={{ marginBottom: "8px" }}>
                                <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>
                                  Return Date
                                </div>
                                <div style={{ fontSize: "13px", color: "#1f2937", fontWeight: "500" }}>
                                  {formatDateHandler2(item.return_date)}
                                </div>
                              </div>
                            )}
                            {item?.comment && (
                              <div style={{ marginBottom: "8px" }}>
                                <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>
                                  Comment
                                  </div>
                                <div style={{ fontSize: "13px", color: "#1f2937", fontWeight: "500" }}>
                                  {item.comment}
                                  </div>
                              </div>
                            )}
                            <div>
                              <span className={`badge badge-soft-${item?.status ? "success" : "danger"}`} style={{
                                fontSize: "11px",
                                padding: "4px 10px",
                                borderRadius: "4px",
                                fontWeight: "600"
                              }}>
                                {item?.status ? "Assigned" : "Not Assigned"}
                              </span>
                            </div>
                          </div>
                      </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{
                  padding: "24px 16px",
                  textAlign: "center",
                  background: "#f9fafb",
                  borderRadius: "6px",
                  border: "1px dashed #e5e7eb"
                }}>
                  <i className="fa-solid fa-history" style={{ 
                    fontSize: "32px", 
                    color: "#d1d5db",
                    marginBottom: "8px",
                    display: "block"
                  }}></i>
                  <p style={{ 
                    margin: 0, 
                    fontSize: "13px",
                    color: "#9ca3af"
                  }}>
                    No assignment history available
                  </p>
                </div>
              )}
            </div>
                      </div>
                     </div>
                    </div>
                 
      {/* Modals */}
      <AllAssetAddPopup 
        getAssetList={() => fetchAssetDetail(assetData?.id)} 
        assetCategory={assetCategory}  
        setSelectedAsset={setSelectedAsset} 
        setLoading={setLoading} 
        selectedAsset={selectedAsset} 
        loading={loading} 
        assetModal={assetModal} 
        setAssetModal={setAssetModal} 
      />
                    <AssetAssignPopup 
                    selectedAsset={assetData}
        getAssetList={() => fetchAssetDetail(assetData?.id)}  
                      setSelectedAssetUser={setSelectedAssetUser} 
                      setLoading={setLoading}
                       selectedAssetUser={selectedAssetUser} 
                       loading={loading} 
                       assetUserModal={assetUserModal} 
        setAssetUserModal={setAssetUserModal}
      />
      <ReturnAssetModal 
        returnAssetModal={returnAssetModal} 
        setReturnAssetModal={setReturnAssetModal} 
        returnAssetHandler={returnAssetHandler} 
        Name="Return Asset" 
      />
    </>
  );
};

export default AssetDetails;
